import { render, staticRenderFns } from "./SearchableCategorizedList.vue?vue&type=template&id=2cd465e7"
import script from "./SearchableCategorizedList.vue?vue&type=script&lang=js"
export * from "./SearchableCategorizedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports